<div class="details-card-wrapper">
  <div class="details-card">
    <div class="details-card-body">
      <div class="row">
        @for (video of videos(); track video.url) {
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 video-container">
          @if (video?.url) {
          <iframe
            class="video-frame"
            [src]="video?.url"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          >
          </iframe>
          }
        </div>
        }
      </div>
    </div>
  </div>
</div>
